var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWellness = function SvgIconWellness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 13.44,
    x: 28,
    y: 22.006,
    stroke: "currentColor",
    strokeWidth: 1.8,
    rx: 2,
    transform: "rotate(180 28 22.006)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.8,
    d: "M25.12 15.286a3.84 3.84 0 0 1-3.84 3.84H7.656a.776.776 0 0 1-.776-.776v-6.128c0-.428.348-.776.776-.776H21.28a3.84 3.84 0 0 1 3.84 3.84Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3,
    cy: 15.106,
    r: 0.9,
    fill: "currentColor",
    transform: "rotate(180 11.3 15.106)"
  })));
};
export { SvgIconWellness as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMjgiIHk9IjIyLjAwNTkiIHdpZHRoPSIyNCIgaGVpZ2h0PSIxMy40NCIgcng9IjIiIHRyYW5zZm9ybT0icm90YXRlKDE4MCAyOCAyMi4wMDU5KSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS44Ii8+CjxwYXRoIGQ9Ik0yNS4xMjAxIDE1LjI4NkMyNS4xMjAxIDE3LjQwNjcgMjMuNDAwOSAxOS4xMjYgMjEuMjgwMSAxOS4xMjZMNy42NTYyOSAxOS4xMjZDNy4yMjc2MiAxOS4xMjYgNi44ODAxMiAxOC43Nzg1IDYuODgwMTIgMTguMzQ5OEw2Ljg4MDEyIDEyLjIyMjFDNi44ODAxMiAxMS43OTM1IDcuMjI3NjIgMTEuNDQ2IDcuNjU2MjkgMTEuNDQ2TDIxLjI4MDEgMTEuNDQ2QzIzLjQwMDkgMTEuNDQ2IDI1LjEyMDEgMTMuMTY1MiAyNS4xMjAxIDE1LjI4NlYxNS4yODZaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjgiLz4KPGVsbGlwc2UgY3g9IjExLjMwMDIiIGN5PSIxNS4xMDU5IiByeD0iMC45IiByeT0iMC45IiB0cmFuc2Zvcm09InJvdGF0ZSgxODAgMTEuMzAwMiAxNS4xMDU5KSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";